module.exports = __webpack_public_path__ + "media/images/table_over_look-2156449e46a8796165c55d0c90de7568.jpg";